import React from "react";
import {
    openAddParentTrackModal,
    setWeekCount,
    setSelectedDays,
    setDayRange
} from "./redux/actions";
import { selectWeekCount, selectSelectedDays, selectDayRange } from "./redux/selectors";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import moment from "moment";
const styles = theme => ({
    button: {
        width: 20,
        height: 20,
        padding: 0
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    icon: {
        width: 20,
        height: 20
    }
});

class RosterSectionControl extends React.Component {
    handleChange = event => {
        this.props.setWeekCount(event.target.value);

        const result = new Array(event.target.value * 7).fill(false).map((e, i) => {
            return moment(this.props.dayRange.start)
                .add(i, "days")
                .toDate();
        });

        this.props.setSelectedDays(result);
        this.props.setDayRange(result[0], result[event.target.value * 7 - 1], false);
    };

    render() {
        const { setView, showDetailView, showAgendaView, classes } = this.props;

        if (typeof showDetailView === "undefined") {
            return null;
        }

        return (
            <div
                style={{
                    gridColumnStart: 1,
                    gridColumnEnd: 1,
                    gridRowStart: 1,
                    gridRowEnd: 2,
                    padding: "5px"
                    // border: "1px solid black"
                }}
            >
                <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showDetailView}
                                onChange={e => {
                                    setView("showDetailView", !showDetailView);
                                }}
                                color="primary"
                            />
                        }
                        label="Detail"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showAgendaView}
                                onChange={e => {
                                    setView("showAgendaView", !showAgendaView);
                                }}
                                color="primary"
                            />
                        }
                        label="Agenda"
                    />
                    {/* <IconButton
                        onClick={this.props.onUndo}
                        style={styles.button}
                        iconstyle={styles.icon}
                    >
                        <Undo />
                    </IconButton>
                    <IconButton
                        onClick={this.props.onRedo}
                        style={styles.button}
                        iconstyle={styles.icon}
                    >
                        <Redo />
                    </IconButton> */}
                </FormGroup>
                <FormGroup row>
                    <Button
                        variant="extendedFab"
                        color="primary"
                        aria-label="Add"
                        className={classes.extendedIcon}
                        onClick={this.props.openAddParentTrackModal}
                    >
                        Crew List
                        <AddIcon />
                    </Button>
                    <FormControl variant="outlined">
                        <Select
                            value={this.props.weekCount}
                            onChange={this.handleChange}
                            variant="outlined"
                        >
                            <MenuItem value={1}>1 Week</MenuItem>
                            <MenuItem value={2}>2 Weeks</MenuItem>
                            <MenuItem value={4}>4 Weeks</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return {
                weekCount: selectWeekCount(store),
                dayRange: selectDayRange(store),
                selectedDays: selectSelectedDays(store)
            };
        },
        {
            openAddParentTrackModal,
            setWeekCount,
            setSelectedDays,
            setDayRange
        }
    )(RosterSectionControl)
);
